import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
} from "shards-react";
import 'react-table/react-table.css'
import Loader from "../../components/common/Loader";
import SummaryPartners from "./SummaryPartners";
import CumulativeTable from "./Cumulative/CumulativeTable";
import AppointmentsTable from "./AppointmentsTable/AppointmentsTable";
import Filters from "./Filters/Filters";
import {getAppointment, getCountByPartner} from "./CallFilter";

const DashboardLive = () => {
    const [appointments, setAppointments] = useState([]);
    const [loadAppointments, setLoadAppointments] = useState(true);
    const [loadCountByPartners, setLoadCountByPartners] = useState(true);
    const [paramsUrl, setParamsUrl] = useState([]);
    const [countByPartner, setCountByPartner] = useState([]);
    const [totalAppointments, setTotalAppointments] = useState(0);
    const [allowAccess, setAllowAccess] = useState(null);

    function sendAllowAccess(allow) {
        setAllowAccess(allow);
    };

    const sendDataToFilters = async (paramsUrl) => {
        setLoadAppointments(true);
        setLoadCountByPartners(true);

        const countByPartner = await getCountByPartner(paramsUrl);
        setLoadCountByPartners(false);
        setCountByPartner(countByPartner.count);

        const appointments = await getAppointment(paramsUrl);
        setLoadAppointments(false);
        setAppointments(appointments.appointments);
        setTotalAppointments(appointments.appointments.total);

        setParamsUrl(paramsUrl);
    };

    return (
        <Container fluid className="main-content-container px-4">
            <Card className="mb-4 mt-4">
                <CumulativeTable />
            </Card>
            <Row>
                <Col className="col-lg lg-6 mb-8 mb-6">
                    <Card small className="user-activity mb-4 mt-4">
                        <Filters
                            onDataReceived = { sendDataToFilters }
                            allowAccess = { sendAllowAccess }
                        />
                    </Card>
                </Col>
            </Row>
            <div>
                { loadCountByPartners ? (
                    <Loader/>
                ) : (
                    <Card className="mb-4">
                        <SummaryPartners countByPartner= { countByPartner } />
                    </Card>
                )}
                { loadAppointments ? (
                    <Loader/>
                ) : (
                    <Card className="mb-4">
                        <AppointmentsTable
                            data = {{ appointments }}
                            totalAppointments = { totalAppointments }
                            allowAccess = { allowAccess }
                            paramsUrl= { paramsUrl }
                        />
                    </Card>
                )}
            </div>
        </Container>
    );
};

export default DashboardLive;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/DashboardLive.js